'use client';

import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { useTranslation } from 'react-i18next';

function MultilineText({ text }: { text: string }) {
  const lines = text.split('\n');
  return (
    <>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
}

export default function Imprint() {
  const { t } = useTranslation();

  return (
    <Layout>
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              {t('pageContent.imprint.title')}
            </h1>
            <p className="text-sm text-gray-500 mb-8">{t('pageContent.imprint.lastUpdated')}</p>

            <div className="prose prose-lg max-w-none">
              <h2>{t('pageContent.imprint.sections.companyInfo.title')}</h2>
              <p>
                <MultilineText text={t('pageContent.imprint.sections.companyInfo.content')} />
              </p>

              <h2>{t('pageContent.imprint.sections.contact.title')}</h2>
              <p>
                <strong>{t('pageContent.imprint.sections.contact.emailLabel')}</strong>{' '}
                <a href={`mailto:${t('pageContent.imprint.sections.contact.email')}`}>
                  {t('pageContent.imprint.sections.contact.email')}
                </a>
              </p>

              <h2>{t('pageContent.imprint.sections.vat.title')}</h2>
              <p>{t('pageContent.imprint.sections.vat.content')}</p>

              <h2>{t('pageContent.imprint.sections.editorialResponsible.title')}</h2>
              <p>{t('pageContent.imprint.sections.editorialResponsible.content')}</p>

              <h2>{t('pageContent.imprint.sections.dispute.title')}</h2>
              <p>
                <MultilineText text={t('pageContent.imprint.sections.dispute.content')} />
              </p>

              <h2>{t('pageContent.imprint.sections.liability.title')}</h2>
              <p>{t('pageContent.imprint.sections.liability.contentLiability')}</p>
              <p>{t('pageContent.imprint.sections.liability.linksLiability')}</p>
              <p>{t('pageContent.imprint.sections.liability.copyright')}</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
